define('collections/PersonCollection',[
    'evertrue',
    'underscore',
    'backbone',
    'ET/ETCollection',
    'models/contact/ContactModel',
    'helpers/mixins'
], function ( EverTrue, _, Backbone, ETCollection, ContactModel, Mixin ) {

    var PersonCollection = ETCollection.extend(
        _.extend({}, Mixin.Collection, {
        urlRoot : 'contacts/v2/search',
        model: ContactModel,
        page: 1,
        contact_total: 0,
        offset: 0,
        limit: 50,

        fetch: function(options) {
            var view = this,
            opts = _.clone(options) || {};
            opts.url = EverTrue.buildBaseURL(this.urlRoot, {"limit" : this.limit, "offset" : this.offset});
            opts.success = function(resp) {
                view.set(resp.items);
                view.contact_total = resp.total;
                view.parse(resp);
                EverTrue.vent.trigger("resetCollection");
            };
            return EverTrue.api(opts, this);
        },

        getCleanResults: function() {
            var persons = [];
            if (this.length) {
                this.each(function(model) {
                    var person_temp = model.getTemplate();
                    persons.push(person_temp);
                });
            }
            return persons;
        },

        setOffset: function() {
            var max_page = Math.ceil(this._pagination.total / this.limit);

            if (this.page <= 0) {
                this.page = 0;
            } else if (this.page > max_page) {
                this.page = max_page;
            }

            this.offset = Math.max(this.page - 1, 0) * this.limit;
        }

    }));

    return PersonCollection;
});

